import { render, staticRenderFns } from "./MatomoCustomReport.vue?vue&type=template&id=44fc4c12&"
import script from "./MatomoCustomReport.vue?vue&type=script&lang=js&"
export * from "./MatomoCustomReport.vue?vue&type=script&lang=js&"
import style0 from "./MatomoCustomReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MatomoCustomReport.vue"
export default component.exports